/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { filter, isEmpty } from 'lodash';
import { FormElems, Alert } from '../../components';
import { validators } from '../../utils/validators';
// import { excludedUserLevels, UNIFIED_MSR } from './constant';

const DownloadFile = props => {
    const {
        actions,
        filterData,
        showDownloadPopup,
        setShowDownloadPopup,
        tableData,
        handleSubmit,
        untouch,
        change,
        generateData,
    } = props;

    const handleOpenActionPopup = actionType => {
        setShowDownloadPopup(!showDownloadPopup);
    };

    useEffect(() => {
        if (generateData.isSuccess) {
            change('fileName', '');
            untouch('downloadFile', 'fileName');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generateData.isSuccess]);

    const handleCloseOpenActionPopup = () => {
        setShowDownloadPopup(false);
        change('fileName', '');
        untouch('downloadFile', 'fileName');
    };

    const handleGenerateSubmit = values => {
        const payload = {
            fileName: values.fileName,
            reportType: 'REQUESTED_APPROVAL',
            ...filterData
        };
        
        actions.generateCheckerReportRequest(payload);
    };

    useEffect(() => {
        return () => {
            handleCloseOpenActionPopup();
        };
    }, []);

    return (
        <div className="download-popup">
            <button
                className={`download ${showDownloadPopup ? 'active' : ''}`}
                onClick={handleOpenActionPopup}
            />
            {showDownloadPopup ? (
                <>
                    <div
                        className="overlay"
                        onClick={handleCloseOpenActionPopup}
                    />
                    <div className="popup-download">
                        <div className="content-body">
                            <form
                                className="popup-download-edit"
                                onSubmit={handleSubmit(handleGenerateSubmit)}
                            >
                                <div className="form-section">
                                    <div className="form-field">
                                        <p className="label">
                                            Enter any name for download file
                                        </p>
                                        <Field
                                            name="fileName"
                                            type="text"
                                            component={FormElems.Input}
                                            placeholder="Enter File Name"
                                        />
                                    </div>
                                </div>
                                {isEmpty(filterData.createdOn) ? (
                                    <Alert customClass="error-msg">
                                        Please select a data range
                                    </Alert>
                                ) : isEmpty(tableData) ? (
                                    <Alert customClass="error-msg">
                                        No data available
                                    </Alert>
                                ) : null}
                                <div className="form-section action">
                                    <FormElems.Button
                                        buttonType="primary"
                                        text="Generate"
                                        isDisable={
                                            isEmpty(tableData) ||
                                            isEmpty(filterData.createdOn)
                                        }
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            ) : null}
        </div>
    );
};

DownloadFile.propTypes = {
    actions: PropTypes.object,
    filterData: PropTypes.object,
    tableData: PropTypes.object,
    showDownloadPopup: PropTypes.bool,
    setShowDownloadPopup: PropTypes.func,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    untouch: PropTypes.func,
    generateData: PropTypes.object,
    isDateRangeFieldRequired: PropTypes.bool,
    dateRangeFieldName: PropTypes.string,
    userLevel: PropTypes.string,
    auth: PropTypes.object,
};

const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};

    const fileName = values?.fileName || '';

    if (REQUIRED(values) || REQUIRED(fileName)) {
        errors.fileName = 'Please enter a File Name';
    } else {
        if (fileName.length > 25) {
            errors.fileName = 'Max 25 characters are allowed in filename';
        }

        const containsValidChars = /^[A-Za-z0-9\-_]+$/i.test(fileName);
        if (!containsValidChars) {
            errors.fileName = 'Only letters, numbers, - and _ are allowed in filename';
        }

        const containsAlphabet = /[A-Za-z]/.test(fileName);
        if (!containsAlphabet) {
            errors.fileName = 'Filename must contain at least one letter (A–Z)';
        }

        const hasNoSpaces = /^\S+$/.test(fileName);
        if (!hasNoSpaces) {
            errors.fileName = 'Spaces are not allowed in filename';
        }
    }

    return errors;
};

export default reduxForm({
    form: 'downloadFile',
    enableReinitialize: true,
    validate,
    destroyOnUnmount: false,
})(DownloadFile);
